var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-shmu"}},[_c('LmsMssComponent',{attrs:{"endpoint":"getmetar","source":"data_shmu","show_header":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }